import React, { useState } from 'react';
import SuggestionList from './suggestion-list';
import './style.scss';

const AutoSuggestion = ({ placeholder, popularSearches, options }) => {
    const [state, setState] = useState({
        isInputEmpty: true,
        selectedPopularSearch: '',
        searchValue: '',
    });

    const handlePopularSearchClick = (value) => {
        setState({
            selectedPopularSearch: value.display_name,
            searchValue: value.display_name,
            isInputEmpty: false,
        });
    }
    const handleChange = (e) => {
        let isInputEmpty = (e.target.value) ? false : true;
        setState({
            selectedPopularSearch: '',
            searchValue: e.target.value,
            isInputEmpty: isInputEmpty,
        });
    }
    const clearInputs = () => {
        setState({
            selectedPopularSearch: '',
            searchValue: '',
            isInputEmpty: true,
        });
    }
    const handleSuggestionClick = (value) => {
        setState({
            selectedPopularSearch: '',
            searchValue: value.display_name,
            isInputEmpty: false,
        });
    }

    return (
        <div className="business-type-suggest-wrap">
            <div className="suggestion-input-wrapper">
                <input type="text" placeholder={placeholder || 'Search...'} name="website-type-search" className="website-type-search-input" value={state.searchValue} onChange={(e) => handleChange(e)} />
                {!state.isInputEmpty && (
                    <span className="suggestion-clear-input" onClick={clearInputs}>
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="https://www.w3.org/2000/svg">
                            <path d="M19.0625 2.52344L17.4766 0.9375L10 8.41406L2.52344 0.9375L0.9375 2.52344L8.41406 10L0.9375 17.4766L2.52344 19.0625L10 11.5859L17.4766 19.0625L19.0625 17.4766L11.5859 10L19.0625 2.52344Z" fill="#A1A1A1" />
                        </svg>
                    </span>
                )}
            </div>

            {"" == state.selectedPopularSearch && "" == state.searchValue && (
                <div className="popular-search-list-wrap">
                    <ul className="popular-search-list">
                        <li className="disabled-label popular-search-list-item">Popular Searches</li>
                        {popularSearches.map((item, index) => {
                            return (
                                <li key={index} className="popular-search-list-item" onClick={() => handlePopularSearchClick(item)}>{item.display_name}</li>
                            )
                        })}
                    </ul>
                </div>
            )}
            <SuggestionList options={options} searchTerm={state.searchValue} selectedPopularSearch={state.selectedPopularSearch} clickEvent={(value) => handleSuggestionClick(value)} />
        </div>
    )
}

export default AutoSuggestion;
